import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useRef,
  useState
} from 'react'

const OverlayCoordinatorContext = createContext(null)

export function OverlayCoordinatorProvider({ children }) {
  const [activeOverlayId, setActiveOverlayId] = useState(null)
  const activeOverlayRef = useRef(null)

  const openOverlay = useCallback(overlayId => {
    if (
      !overlayId ||
      (activeOverlayRef.current && activeOverlayRef.current !== overlayId)
    ) {
      return false
    }

    activeOverlayRef.current = overlayId
    setActiveOverlayId(overlayId)
    return true
  }, [])

  const closeOverlay = useCallback(overlayId => {
    if (activeOverlayRef.current !== overlayId) return false

    activeOverlayRef.current = null
    setActiveOverlayId(null)
    return true
  }, [])

  const value = useMemo(
    () => ({
      activeOverlayId,
      closeOverlay,
      openOverlay
    }),
    [activeOverlayId, closeOverlay, openOverlay]
  )

  return (
    <OverlayCoordinatorContext.Provider value={value}>
      {children}
    </OverlayCoordinatorContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useOverlayCoordinator() {
  const context = useContext(OverlayCoordinatorContext)

  if (!context) {
    throw new Error(
      'useOverlayCoordinator must be used within an OverlayCoordinatorProvider'
    )
  }

  return context
}
